export class Answer {
  constructor( public type: string, public value : any){}
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/answer.ts